import { render, staticRenderFns } from "./classRank.vue?vue&type=template&id=2bc4dabc&scoped=true"
import script from "./classRank.vue?vue&type=script&lang=js"
export * from "./classRank.vue?vue&type=script&lang=js"
import style0 from "./classRank.vue?vue&type=style&index=0&id=2bc4dabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4dabc",
  null
  
)

export default component.exports